import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import FTMDD from './FTMDD';
import IntroMDD from './IntroMDD';
import ResultsMDD from './ResultsMDD';
import SUGMDD from './SUGMDD';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const MolecularDynamicsLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#IntroMDD') {
      setBackI(appColors['ColorD']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#FTMDD') {
      setBackI('transparent');
      setBackII(appColors['ColorD']);
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#SUGMDD') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorD']);
      setBackIV('transparent');
    } else if (key === '#ResultsMDD') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorD']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#IntroMDD' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorD'], fontSize: '3vh'}}>Introduction</Text></Content>}/>
          <Link href='#FTMDD' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorD'], fontSize: '1.2vh'}}>Fundamentals and troubleshooting</Text></Content>}/>
          <Link href='#SUGMDD' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorD'], fontSize: '1.7vh'}}>Software usage guide</Text></Content>}/>
          <Link href='#ResultsMDD' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorD'], fontSize: '3vh'}}>Results</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorD'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> D&nbsp;<br/> Y&nbsp;<br/> N&nbsp;<br/> A&nbsp;<br/> M&nbsp;<br/> I&nbsp;<br/> C&nbsp;<br/> S&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='IntroMDD'>
              <IntroMDD/>
            </div>
            <div id='FTMDD'>
              <FTMDD/>
            </div>
            <div id='SUGMDD'>
              <SUGMDD/>
            </div>
            <div id='ResultsMDD'>
              <ResultsMDD/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MolecularDynamicsLogic;
